export default __webpack_public_path__ + "a52cdf065a5b05c9ec89726dfd92244c.png";